<script>

export default {
    name: 'Parte5'
}

</script>

<template>
    <div class="main">

        <div class="bloco1">
            <div class="bloco2">
                <img class="logo" src="../assets/imagens/logo-simbolo.png" alt="">
            <p class="titulo">ALGUNS DOS NOSSOS CLIENTES</p>
            </div>
            <div class="bloco3">
                <div class="bloco4">
                    <div class="imagem1"></div>
                    <div class="imagem2"></div>
                    <div class="imagem3"></div> 
                    <div class="imagem4"></div>                   
                </div>
                <div class="bloco4">
                    <div class="imagem5"></div>
                    <div class="imagem6"></div>
                    <div class="imagem7"></div>
                    <div class="imagem8"></div>
                </div>
                <div class="bloco4">
                    <div class="imagem9"></div>
                    <div class="imagem10"></div>
                    <div class="imagem11"></div>
                    <div class="imagem12"></div>
                </div>
                
            </div>
        </div>

    </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Staatliches&display=swap');

@media (max-width: 900px) {
.main{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    max-width: 100vw;
    margin: 2rem 0rem;
}

.logo {
    width: 0%;
    opacity: 70%;
    margin-right: 10px;
}
.titulo {
    color: #2e74c4;
    letter-spacing: 2px;
    font-size: 1rem;
    width: 100%;
    text-align: center;
    font-weight: bold;
}
.bloco1 {
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.bloco2{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1%;
}
.bloco4{
    margin-top: 2rem;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
}
.bloco3{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
}
.imagem1 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/images.png');        
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 6rem;
    height: 4rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem2 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/images (1).png');
    /* Imagem de fundo */
    background-size:100%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 6rem;
    height: 4rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem3 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/arcelormittal-logo.png');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 6rem;
    height: 4rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem4 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/andritz.png');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 6rem;
    height: 4rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem5 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/brasigran.webp');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 6rem;
    height: 4rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem6 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/bts.png');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 6rem;
    height: 4rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem7 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/imetame.jpg');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 6rem;
    height: 4rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem8 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/ocyan.jpg');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 6rem;
    height: 4rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem9 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/samarco.png');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 6rem;
    height: 4rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem10 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/technip.png');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 6rem;
    height: 4rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem11 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/metalvix.jpeg');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 6rem;
    height: 4rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem12 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/vamtec.png');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 6rem;
    height: 4rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
}
@media (min-width: 901px) {
.main{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    max-width: 100vw;

}

.logo {
    width: 6%;
    opacity: 70%;
}
.titulo {
    color: #2e74c4;
    letter-spacing: 2px;
    font-size: 1.2rem;
    width: 50%;
    text-align: center;
    font-weight: bold;
}
.bloco1 {
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.bloco2{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 1%;
}
.bloco4{
    margin-top: 2rem;
    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 2rem;
}
.imagem1 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/images.png');        
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 10rem;
    height: 8rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem2 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/images (1).png');
    /* Imagem de fundo */
    background-size:100%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 10rem;
    height: 8rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem3 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/arcelormittal-logo.png');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 10rem;
    height: 8rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem4 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/andritz.png');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 10rem;
    height: 8rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem5 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/brasigran.webp');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 10rem;
    height: 8rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem6 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/bts.png');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 10rem;
    height: 8rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem7 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/imetame.jpg');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 10rem;
    height: 8rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem8 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/ocyan.jpg');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 10rem;
    height: 8rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem9 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/samarco.png');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 10rem;
    height: 8rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem10 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/technip.png');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 10rem;
    height: 8rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem11 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/metalvix.jpeg');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 10rem;
    height: 8rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
.imagem12 {
    background:
        linear-gradient(#ffffff00, #ffffff00),
        /* Gradiente escuro semi-transparente */
        url('../assets/clientes/vamtec.png');
    /* Imagem de fundo */
    background-size:90%;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat:no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    width: 10rem;
    height: 8rem;
    border:2px solid #00000038;
    border-radius: 10px;
}
}
</style>